module.exports = __webpack_public_path__ + "static/media/bogota-10.01ccd1e0.jpg";